(function () {
    "use strict";

    angular.module("app").directive("deactivateTabNavigation", DeactivateTabNavigationDirective);
    DeactivateTabNavigationDirective.$inject = ["tabNavigationService"];
    function DeactivateTabNavigationDirective(tabNavigationService, ) {
        return {
            restrict: 'A',
            multiElement: true,
            link: () => { tabNavigationService.ActivateFlatView(); }
        };
    }
})();